<script>
	import { onMount, afterUpdate } from 'svelte';
	import 'overlayscrollbars/overlayscrollbars.css';
	import { OverlayScrollbars } from 'overlayscrollbars';
	import data from '../common/data/Layoutmenudata';
	import Link from 'svelte-link';
	import { page } from '$app/stores';
	import { browser } from '$app/environment';
	import { _ } from 'svelte-i18n';
	import { userObj } from '../stores/authUserStore.js';
	import tippy from 'sveltejs-tippy';


	let dataRender = [];

	// Subscribe to userObj store
	userObj.subscribe((value) => {
		dataRender = data.Navdata;
		setTimeout(() => {
			activeMenu();
		}, 100);
	});

	// $: {
	// 	dataRender = data.Navdata;
	// 	console.log('dataRender CHANGE:', dataRender);
	// }

	// after routeing complete call afterUpdate function
	afterUpdate(() => {
		removeActiveDropdown();
		let currUrl = $page.url.pathname;
		if (currUrl) {
			let item = document.querySelector('.vertical-menu a[href=\'' + currUrl + '\']');
			// if item is null, then try again without the slash at the end
			if (!item) {
				// cut the last char of the string.
				currUrl = currUrl.substring(0, currUrl.length - 1);
				item = document.querySelector('.vertical-menu a[href=\'' + currUrl + '\']');
			}
			if (item) {
				item.classList.add('active');
				const parent1 = item.parentElement;
				if (parent1) {
					parent1.classList.add('mm-active');
					const parent2 = parent1.parentElement;
					if (parent2) {
						parent2.classList.add('mm-show');
						if (parent2.previousElementSibling) {
							parent2.previousElementSibling.classList.add('mm-active');
						}
						const parent3 = parent2.parentElement.parentElement;
						if (parent3) {
							parent3.classList.add('mm-show');
							if (parent3.previousElementSibling) {
								parent3.previousElementSibling.classList.add('mm-active');
							}
						}
					}
				}
			}
		}
	});

	const options = {
		scrollbars: {
			visibility: 'auto', // You can adjust the visibility ('auto', 'hidden', 'visible')
			autoHide: 'move', // You can adjust the auto-hide behavior ('move', 'scroll', false)
			autoHideDelay: 100,
			dragScroll: true,
			clickScroll: false,
			theme: 'os-theme-dark',
			pointers: ['mouse', 'touch', 'pen']
		}
	};

	onMount(() => {
		const menuElement = document.querySelector('#vertical-menu');
		OverlayScrollbars(menuElement, options);
		// console.log('onMount set dataRenderer');

		dataRender = data.Navdata;
		activeMenu();

		let currUrl = $page.url.pathname;
		if (currUrl) {
			let item = document.querySelector('.vertical-menu a[href=\'' + currUrl + '\']');
			// if item is null, then try again without the slash at the end
			if (!item) {
				// cut the last char of the string.
				currUrl = currUrl.substring(0, currUrl.length - 1);
				item = document.querySelector('.vertical-menu a[href=\'' + currUrl + '\']');
			}
			//
			if (item) {
				item.classList.add('active');
				item.scrollIntoView({ behavior: 'smooth', block: 'center' });
				const parent1 = item.parentElement;
				if (parent1) {
					parent1.classList.add('mm-active');
					const parent2 = parent1.parentElement;
					if (parent2) {
						parent2.classList.add('mm-show');
						if (parent2.previousElementSibling) {
							parent2.previousElementSibling.classList.add('mm-active');
						}
						const parent3 = parent2.parentElement.parentElement;
						if (parent3) {
							parent3.classList.add('mm-show');
							if (parent3.previousElementSibling) {
								parent3.previousElementSibling.classList.add('mm-active');
							}
						}
					}
				}
			}
		}
	});

	const clickHandlers = new Set();
	const activeMenu = () => {
		if (browser) {
			document.querySelectorAll('.vertical-menu .has-arrow').forEach((menu) => {
				// console.log('MENU Adding check click handler: ', menu.innerText);
				// check to see if it already has a click handler
				if (!clickHandlers.has(menu)) {
					// console.log('MENU Adding click handler: ', menu.innerText);
					menu.addEventListener('click', () => {
						// chek if active, if so remove active
						if (menu.classList.contains('mm-active')) {
							menu.classList.remove('mm-active');
							if (menu.nextElementSibling) {
								menu.nextElementSibling.classList.remove('mm-show');
								menu.nextElementSibling.classList.add('mm-collapse');
							}
						} else {
							menu.classList.add('mm-active');
							if (menu.nextElementSibling) {
								menu.nextElementSibling.classList.remove('mm-collapse');
								menu.nextElementSibling.classList.add('mm-show');
							}
						}
					});
				}
				clickHandlers.add(menu);
			});

			document.querySelectorAll('.sub-menu a').forEach((submenu) => {
				submenu.addEventListener('click', () => {
					removeActiveDropdown();
					submenu.classList.add('active');
					if (submenu.nextElementSibling) {
						submenu.nextElementSibling.classList.add('mm-show');
					}
					if (submenu.parentElement) {
						submenu.parentElement.classList.add('mm-active');
						const parent1 = submenu.parentElement.parentElement;
						if (parent1) {
							parent1.classList.add('mm-show');
							if (parent1.previousElementSibling) {
								parent1.previousElementSibling.classList.add('mm-active');
							}

							const parent2 = parent1.parentElement.parentElement;
							if (parent2) {
								parent2.classList.add('mm-show');
								if (parent2.previousElementSibling) {
									parent2.previousElementSibling.classList.add('mm-active');
								}
							}
						}
					}
				});
			});
		}
	};

	const removeActiveDropdown = () => {
		document.querySelectorAll('.vertical-menu .has-arrow').forEach((menu) => {
			// console.log('MENU Remove Active Dropdown for ', menu.innerHTML);
			if (menu.nextElementSibling) {
				menu.nextElementSibling.classList.add('mm-collapse');
				menu.nextElementSibling.classList.remove('mm-show');
				menu.classList.remove('mm-active');
			}
		});

		document.querySelectorAll('.sub-menu a').forEach((submenu) => {
			submenu.classList.remove('active');
			if (submenu.parentElement) {
				submenu.parentElement.classList.remove('mm-active');
			}
		});
	};

	// Look in the item for "auth_see" and "auth_access"
	// auth_see: is permission to see but not access an Item
	// auth_access: is permission to see and access an Item
	const checkMenuItemAuth = (item) => {
		if (item.staff_only) return $userObj.is_staff === true || $userObj.is_staff === 'true' || $userObj.is_superuser === true || $userObj.is_superuser === 'true';
		// console.log('checkMenuItemAuth:', item.label, item.auth_access);
		// if (item.label.toLowerCase() === 'research') {
		// 	console.log("Research")
		// }
		if (($userObj.Authenticated === undefined ||
				($userObj.Authenticated === false || $userObj.Authenticated === 'false')) &&
			item.auth_see === true) {
			return true;
		}
		// if we don;t have auth_see or auth_access in the item, return true
		if (!item.hasOwnProperty('auth_access')) {
			return true;
		}
		// console.log('checkMenuItemAuth:', item.label, item.auth_access);
		// userObj not available yet?
		if ($userObj.Authenticated === undefined) {
			return false;
		}
		// Is user Authenticated?
		if ($userObj.Authenticated === 'false') {
			return false;
		}
		// test if uo is an empty object, if so return false
		if (Object.keys($userObj).length === 0 && $userObj.constructor === Object) {
			return false;
		}
		// check if uo has attribute auth_access., if not return false
		if (!$userObj.hasOwnProperty('AccessGroup')) {
			return false;
		}
		if ($userObj.AccessGroup.length === 0) {
			return false;
		}

		// build a test array, add admin to the array if user is_superuser.
		let test_array = [];
		if ($userObj.is_superuser === 'true' || $userObj.is_superuser === true) {
			// add "Admin" to uo.AccessGroup
			test_array = [...$userObj.AccessGroup, 'authenticated', 'admin'];
		} else {
			test_array = [...$userObj.AccessGroup, 'authenticated'];
		}
		// item.auth_access is an array of strings
		// check if any of uo.AccessGroup is in item.auth_access
		// if yes, return true
		// if no, return false
		let auth_check = item.auth_access.some((r) => test_array.includes(r));
		// console.log('auth_check for ', item.auth_access, ':', auth_check);
		return auth_check;
	};

	const checkAuthSee = (item) => {
		let res = undefined;
		if (item.hasOwnProperty('auth_see') && $userObj.hasOwnProperty('Authenticated')) {
			res = (($userObj.Authenticated === 'false') && (item.auth_see));
		} else {
			res = false;
		}
		return res;
	};

	const safeString = (str) => {
		// remove all non alpha numeric characters
		return str.replace(/[^a-zA-Z0-9]/g, '');
	};


</script>

<div class="vertical-menu">
	<div class="h-100" id="vertical-menu">
		<!--- Sidemenu -->
		<div id="sidebar-menu">
			<!-- Left Menu Start -->
			<ul class="metismenu list-unstyled" id="side-menu">
				{#each dataRender as item}
					{#if checkMenuItemAuth(item)}
						{#if item.isHeader}
							<li class="menu-title" key="t-menu">{$_(item.label)}</li>
						{:else if item.subMenu}
							<li>
								{#if item.auth_see === true && !$userObj.Authenticated}
									<Link href={null} class="has-arrow waves-effect">
										<i class={item.icon}></i>
										<span>{$_(item.label)}*</span>
									</Link>
								{:else}
									<Link href={null} class="has-arrow waves-effect">
										<i class={item.icon}></i>
										<span>{$_(item.label)}</span>
									</Link>
								{/if}
								<ul class="sub-menu mm-collapse">
									{#each item.subMenu as subMenu}
										{#if checkMenuItemAuth(subMenu)}
											{#if subMenu.isChildItem}
												<li>
													<Link href="#" class="has-arrow waves-effect" on:click={(event) => event.preventDefault()}>
														<span>{$_(subMenu.label)}</span>
													</Link>
													<ul class="sub-menu mm-collapse">
														{#each subMenu.childItems as childItem}
															<li>
																<Link href={childItem.link}>{$_(childItem.label)}</Link>
															</li>
														{/each}
													</ul>
												</li>
											{:else}
												{#if checkMenuItemAuth(subMenu)}
													<li>
														{#if checkAuthSee(subMenu)}
															<div use:tippy={
															{
																content:"Please login to access this menu item",
																placement:"right"
															}
															}>
																<Link id="lnk-{safeString(subMenu.label)}"
																			href={null}>{$_(subMenu.label)}*
																</Link>
															</div>
														{:else}
															<Link href={subMenu.link}>{$_(subMenu.label)}</Link>
														{/if}
													</li>
												{/if}
											{/if}
										{/if}
									{/each}
								</ul>
							</li>
						{:else}
							<li>
								<Link href={item.link} class="waves-effect">
									<i class={item.icon}></i><span>{$_(item.label)}</span>
								</Link>
							</li>
						{/if}
					{/if}

				{/each}
			</ul>
		</div>
	</div>
</div>
